import { PageHeader } from 'common.ui';
import React, { FunctionComponent, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import './Page.scss';

interface IProps {
  header?: string;
  stepCurrent?: number;
  stepTotal?: number;
  renderStepInfo?: (stepCurrent: number, stepTotal: number) => string;
  title?: string | string[];
}

const Page: FunctionComponent<IProps> = ({ header, stepCurrent, stepTotal, title, children, renderStepInfo }) => {
  const resolvedTitle = useMemo(() => {
    if (!title) {
      return 'MinSide';
    }

    const titleArray = Array.isArray(title) ? title : [title];
    const minsideTitleArray = [...titleArray, 'MinSide'].filter((t) => t); // Filter out empty strings

    return minsideTitleArray.join(' - ');
  }, [title]);

  return (
    <>
      <Helmet>
        <title>{resolvedTitle}</title>
      </Helmet>

      <div className='page-container'>
        {header && (
          <PageHeader value={header} stepCurrent={stepCurrent} stepTotal={stepTotal} renderStepInfo={renderStepInfo} />
        )}
        {children}
      </div>
    </>
  );
};

export default Page;
